import type { RouteObject } from 'react-router';

import { createPaths } from '@ricoh/ria.client.core/utils/router/path';

/** Guest route. */
const guestRoute: RouteObject = {
  lazy: async () => (await import('~/components/layout/welcome')).default,

  children: [
    // Internal SingIn
    {
      path: '',
      index: true,
      lazy: async () => (await import('~/components/page/guest/signin')).default,
    },
    // External SingIn
    {
      path: 'sso',
      lazy: async () => (await import('~/components/page/guest/sso')).default,
    },

    // Verify Create password
    {
      path: 'initial-setup',
      lazy: async () => (await import('~/components/page/guest/initial-setup')).default,
    },

    // Reset password
    {
      path: 'reset-password',
      lazy: async () => (await import('~/components/page/guest/reset-password')).default,
    },
    // Verify Reset password
    {
      path: 'forgot-password',
      lazy: async () => (await import('~/components/page/guest/forgot-password')).default,
    },

    // Create password
    {
      path: 'create-password',
      lazy: async () => (await import('~/components/page/guest/create-password')).default,
    },
  ],
};

/** Guest paths. */
export const guestPaths = createPaths(guestRoute);

export default guestRoute;
